// @flow
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import EventNoteIcon from "@material-ui/icons/EventNote";
import { withStyles } from "@material-ui/core/styles";

import { ColorSchema } from "../../global/types/scss";
import { buttonStyles } from "../../global/components/StyledButtons";
import { CopyRight } from "./CopyRight";

const Transition = (props): React$Element<*> => (
  <Slide direction="down" {...props} />
);

type TermsStatesType = {
  open: boolean
};

class Terms extends React.Component<*, TermsStatesType> {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  CheckTerms = () => {
    this.props.CheckTerms();
    this.handleRequestClose();
  }

  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <span>
        <span onClick={this.handleClickOpen} className="form-link-green" style={{ color: ColorSchema("primary") }}>Terms and Conditions.</span>
        <Dialog
          disableBackdropClick
          maxWidth="md"
          open={this.state.open}
          onClose={this.handleRequestClose}
          TransitionComponent={Transition}
        >
          <AppBar position="absolute">
            <Toolbar style={{ background: ColorSchema("primary") }}>
              <IconButton color="inherit" onClick={this.handleRequestClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="title" color="inherit">
                Terms And Conditions
              </Typography>
              <EventNoteIcon className="left-margin-5" />
            </Toolbar>
          </AppBar>
          <div className="mui-form">
            <div className="terms-block inner-wrapper" style={{ color: ColorSchema("primary") }}>
              <span className="title">Terms and Conditions ("Terms")</span><br />
              <span className="title">Last updated: December 12, 2017</span><br /><br />
              Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using this website (the "Service") operated by Imagus Technology Pty Ltd ("us", "we", or "our").<br /><br />
              Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.<br /><br />
              By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.<br /><br />

              <span className="title">Termination</span><br />
              We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.<br /><br />
              All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.<br /><br />

              <span className="title">Disclaimer of Warranties</span><br />
              The website is provided “as is”. Imagus and its suppliers and licensors hereby disclaim all warranties of any kind, express or implied, including, without limitation, the warranties of merchantability, fitness for a particular purpose and non-infringement. Neither Imagus nor its suppliers and licensors, makes any warranty that the website will be error free or that access thereto will be continuous or uninterrupted. You understand that you download from, or otherwise obtain content or services through, the website at your own discretion and risk.<br /><br />

              <span className="title">Privacy Policy</span><br />
              Our Privacy Policy related to this web site is:
              <ul>
                <li>Any personal information (e.g. your name, your email address, your image etc) provided by you or via your browser (e.g. via cookies) will be for our use only or for a purpose to which you are informed of at the time of collecting the personal information about you.</li>
                <li>You must give us express permission to publish your image(s) or any other personal data via this website.</li>
              </ul>

              <span className="title">Governing Law</span><br />
              These Terms shall be governed and construed in accordance with the laws of Queensland, Australia, without regard to its conflict of law provisions.<br /><br />
              Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.<br /><br />

              <span className="title">Changes</span><br />
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.<br /><br />
              By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.<br /><br />

              <span className="title">Contact Us</span><br />
              If you have any questions about these Terms, please contact us at info@imagus.com.au.<br /><br /><br />

              <Button color="primary" variant="raised" type='submit' id="submitBtn" className={classes.primaryBtn} onClick={this.CheckTerms}>Accept</Button>
              <Typography variant="subheading" className="form-text copywrite-bottom" style={{ color: ColorSchema("primary") }}>
                <span className="">{CopyRight}</span>
              </Typography>
            </div>
          </div>
        </Dialog>
      </span>
    );
  }
}

export default withStyles(buttonStyles)(Terms);


// WEBPACK FOOTER //
// ./src/conference/containers/Terms.js